import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Box, darken, lighten, useTheme, } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
function AccordionWithValidationImpl(props) {
    const { validation_result, validation_warnings_result, header, headerProps, detailsProps, children, ...rest } = props;
    const theme = useTheme();
    const error = useMemo(() => validation_result != null, [validation_result]);
    const warning = useMemo(() => validation_result == null && validation_warnings_result != null, [validation_result, validation_warnings_result]);
    return (_jsxs(Accordion, { sx: {
            // boxShadow: 'none',
            '& .MuiAccordionSummary-content > .MuiSvgIcon-root': {
                color: 'text.secondary',
                mr: 1,
            },
        }, ...rest, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMore, {}), sx: {
                    backgroundColor: darken(theme.palette.background.paper, 0.0),
                    color: lighten(theme.palette.text.primary, 0.2),
                    '&:hover': {
                        backgroundColor: theme.palette.mode === 'dark'
                            ? darken(theme.palette.background.paper, 0.07)
                            : darken(theme.palette.background.paper, 0.03),
                    },
                    ...(warning && {
                        backgroundColor: theme.palette.warning.light,
                        color: theme.palette.warning.contrastText,
                        '& .MuiSvgIcon-root, & .material-dnd': {
                            color: theme.palette.warning.contrastText,
                        },
                    }),
                    ...(error && {
                        backgroundColor: theme.palette.error.light,
                        color: theme.palette.error.contrastText,
                        '& .MuiSvgIcon-root, & .material-dnd': {
                            color: theme.palette.error.contrastText,
                        },
                    }),
                }, ...headerProps, children: header }), _jsx(AccordionDetails, { ...detailsProps, children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, children: [validation_result != null &&
                            typeof validation_result === 'string' &&
                            validation_result.length > 0 && (_jsx(Alert, { severity: "error", children: _jsx(AlertTitle, { children: validation_result }) })), validation_result == null &&
                            validation_warnings_result != null &&
                            typeof validation_warnings_result === 'string' && (_jsx(Alert, { severity: "warning", children: _jsx(AlertTitle, { children: validation_warnings_result }) })), children] }) })] }));
}
export const AccordionWithValidation = memo(AccordionWithValidationImpl);
